import React, { useState, useEffect } from "react";
import bankIco from '../../../assets/icons/interface/manat.svg';
import clockIco from "../../../assets/icons/interface/clock.svg";
import routeIco from "../../../assets/icons/interface/startRoute.svg";
//import logoExample from "../../../assets/logo/logoExample.png";
import phoneIco from "../../../assets/icons/interface/phone.svg";
import linkIco from "../../../assets/icons/interface/external-link.svg";

// Импортируем иконки для каждой категории
import beachesIco from '../../../assets/icons/interface/beaches.svg';
import hotelIco from '../../../assets/icons/interface/hotel.svg';
import entertainmentIco from '../../../assets/icons/interface/entertainment.svg';
import bankCategoryIco from '../../../assets/icons/interface/bank.svg';
import societyIco from '../../../assets/icons/interface/society.svg';
import barIco from '../../../assets/icons/interface/bar.svg';
import fastfoodIco from '../../../assets/icons/interface/fastfood.svg';
import restaurantIco from '../../../assets/icons/interface/restaurant.svg';
import shopIco from '../../../assets/icons/interface/shop.svg';
import educationIco from '../../../assets/icons/interface/education.svg';
import estateIco from '../../../assets/icons/interface/estate.svg';
import otherIco from '../../../assets/icons/interface/other.svg';

import { useRoute } from "../../../utils/RouteContext";

/**
 * @param {{ onClose: () => void, markerData: any }} props
 * markerData – это объект свойств маркера (feature.properties), который вы передаёте
 * из ViewRoadNetwork в ActionSheet, а затем сюда.
 */
const PlaceCardComponent = ({ onClose, onRouteClick, data = {} }) => {
    // Состояние для отслеживания загрузки изображения
    const [logoLoaded, setLogoLoaded] = useState(true);
    const { setEndPoint } = useRoute();

    // Добавляем useEffect для сброса состояния при изменении данных
    useEffect(() => {
        setLogoLoaded(true); // Сбрасываем флаг при получении новых данных
    }, [data]);

    // Маппинг категорий с их форматированными названиями
    const categoryNames = {
        "beaches": "Пляжи и клубы",
        "hotel": "Отели",
        "entertainment": "Развлечения",
        "bank": "Банки и банкоматы",
        "society": "Сервис и услуги",
        "sport": "Спорт",
        "food": "Рестораны",
        // "bar": "Бары",
        // "fastfood": "Фастфуд",
        // "restaurant": "Рестораны",
        "shop": "Магазины",
        "education": "Дети и обучение",
        "estate": "Недвижимость",
        "other": "Другое"
    };

    // Маппинг категорий с их иконками
    const categoryIcons = {
        "beaches": beachesIco,
        "hotel": hotelIco,
        "entertainment": entertainmentIco,
        "bank": bankCategoryIco,
        "society": societyIco,
        "bar": barIco,
        "fastfood": fastfoodIco,
        "restaurant": restaurantIco,
        "shop": shopIco,
        "education": educationIco,
        "estate": estateIco,
        "other": otherIco
    };

    // Если каких-то полей нет, подставляем "Н/Д"
    const {
        name = "Неопознанный объект",
        description = "Описание временно отсутствует, и скоро будет добавлено",
        operatingHours = {}, // Добавьте эту строку вместо time
        category = "other",
        cost = "Н/Д",
        phone = "Н/Д",
        link = "Н/Д",
        markerIconName = null,
    } = data;


// Формируем строку времени из operatingHours
    const time = operatingHours && operatingHours.start && operatingHours.end
        ? `${operatingHours.start}-${operatingHours.end}`
        : "уточняется";

    const isOpenNow = () => {
        if (!operatingHours.start || !operatingHours.end) return true; // Если нет данных о времени, считаем открытым

        const now = new Date();
        const currentHours = now.getHours();
        const currentMinutes = now.getMinutes();

        // Преобразуем время из строк "HH:MM" в минуты
        const startParts = operatingHours.start.split(':');
        const endParts = operatingHours.end.split(':');

        const startMinutes = parseInt(startParts[0]) * 60 + parseInt(startParts[1]);
        const endMinutes = parseInt(endParts[0]) * 60 + parseInt(endParts[1]);
        const nowMinutes = currentHours * 60 + currentMinutes;

        return nowMinutes >= startMinutes && nowMinutes <= endMinutes;
    };

// Класс для цвета времени
    const timeClassName = `card__item-info-bubble-time ${!isOpenNow() ? 'closed' : ''}`;

    // Получаем форматированное название категории
    const formattedCategory = categoryNames[category.toLowerCase()] || categoryNames.other;

    // Получаем иконку для категории
    const categoryIcon = categoryIcons[category.toLowerCase()] || categoryIcons.other;

    // Проверяем, нужно ли отображать блок с ценой
    const showCost = cost !== "Н/Д";

    // Формируем путь к логотипу, если указан markerIconName
    const logoPath = markerIconName ? `/icons/round_logo/${markerIconName}.png` : null;

    // Обработчик ошибки загрузки изображения
    const handleImageError = () => {
        setLogoLoaded(false);
    };

    // Обработчик клика по кнопке
    const handleRouteClick = () => {
        // Устанавливаем конечную точку из данных карточки
        setEndPoint({
            name: data.name,
            lat: data.latitude,
            lng: data.longitude
        });

        console.log('Нажали на кнопку "Маршрут". Передаём в setEndPoint:', {
            name: data.name,
            lat: data.latitude,
            lng: data.longitude
        });

        // Закрываем текущее модальное окно
        onClose();

        // Используем setTimeout, чтобы дать время закрыться текущему модальному окну
        setTimeout(() => {
            // Отправляем событие для открытия нового модального окна с маршрутом
            document.dispatchEvent(new CustomEvent('openRouteModal', {
                detail: { forceResetOnMount: true }
            }));
        }, 300);
    };



    return (
        <div className="container">
            <div className="container__header">
                <h1>{name}</h1>
            </div>

            <div className="card__body">
                <div className="card__item-info">
                    <text>{description}</text>
                </div>
                {logoPath && logoLoaded && (
                    <div className="card__item-logo__container">
                        <img
                            src={logoPath}
                            alt={`${name} logo`}
                            onError={handleImageError}
                        />
                    </div>
                )}
            </div>

            <div className="card__items">
                <div className="card__item-info-bubbles">
                    <text className={timeClassName}>
                        <img src={clockIco} alt="Clock Icon"/>
                        {time}
                    </text>
                    <text className="card__item-info-bubble">
                        <img src={categoryIcon} alt="Category Icon" />
                        {formattedCategory}
                    </text>
                    {showCost && (
                        <text className="card__item-info-bubble">
                            <img src={bankIco} alt="Cost Icon" />
                            {cost}
                        </text>
                    )}
                </div>
            </div>

            <div className="card__footer">
                <div className="card__footer-bubbles">
                    <div className="card__footer-bubbles-bubble" href={phone}>
                        <img src={phoneIco} alt="Phone Icon"/>
                        <text> Позвонить</text>
                    </div>
                    <div className="card__footer-bubbles-bubble" href={link}>
                        <img src={linkIco} alt="Link Icon"/>
                    </div>
                </div>
                <button className="card__footer-route" onClick={handleRouteClick}>
                    <img src={routeIco} alt="Route Icon"/>
                    Маршрут
                </button>
            </div>
        </div>

    );
};

export default PlaceCardComponent;